import BioGlimmerLOGO from "../../Components/BioGlimmer LOGO.svg"
import "./TitleBackground.css"
import {motion} from "framer-motion";
import React from "react";

export default function Title(){
    return(
        // <img className="w-80 h-80 mx-auto" src={BioGlimmerLOGO} alt=""/>*/}
        // <div className="relative h-[calc(100vh-68px)]">
        <div className="relative min-h-screen">
            <div className="text-container">
                <div className="flex flex-col md:flex-row py-10 items-center justify-center">
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.4}}
                        viewport={{once: false}}
                    >
                        <img className="w-[16rem] h-[16rem] lg:w-[28rem] lg:h-[28rem] xl:w-[32rem] xl:h-[32rem] md:mr-12 lg:mr-20 xl:mr-24" src={BioGlimmerLOGO} alt=""/>
                    </motion.div>
                    <div className="text-4xl lg:text-8xl font-extralight">
                        <motion.div
                            className="mt-8 md:mt-0"
                            variants={{
                                hidden: { opacity: 0, x: 50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.4}}
                            viewport={{once: false}}
                        >
                            BioGlimmer
                        </motion.div>
                        <motion.div
                            className="mt-8 md:mt-16"
                            variants={{
                                hidden: { opacity: 0, x: 50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.6}}
                            viewport={{once: false}}
                        >
                            iGEM 2024
                        </motion.div>
                        <motion.div
                            className="mt-8 md:mt-16"
                            variants={{
                                hidden: { opacity: 0, x: 50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.8}}
                            viewport={{once: false}}
                        >
                            Stockholm
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className="gradient-bg">
                <svg>
                    <defs>
                        <filter id="svg">
                            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="svg" />
                            <feBlend in="SourceGraphic" in2="svg" />
                        </filter>
                    </defs>
                </svg>
                <div className="gradients-container">
                    <div className="g1"></div>
                    <div className="g2"></div>
                    <div className="g3"></div>
                    <div className="g4"></div>
                    <div className="g5"></div>
                    <div className="interactive"></div>
                </div>
            </div>
        </div>
    )
}